
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-iconTop">
        <a href="#home"><i className="bx bxs-up-arrow-circle"></i></a>
      </div>
    </footer>
  );
};

export default Footer;
